import {createEntityService} from "base/entity/service";
import {
    world_api_adapter,
    world_api_list_adapter,
    createWorld,
    createWorldList,
} from "./World";
import {Service as DefaultService} from "app/common/service";

const entityService = createEntityService(
    "/api/app/world",
    createWorld,
    createWorldList,
    world_api_adapter,
    world_api_list_adapter
);

export const WorldService = DefaultService(entityService);
